


















































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import { EUserType, IUserChainRole, ZUNTA_DATA_ENTRY_ID } from '@zunta/configurations'
import { UserModule } from '@/store/modules/user.module'
import Icon from '@/components/Icon.vue'
import { STORAGE_URL } from '@/constants'
import DateInput2 from '@/components/inputs/DateInput2.vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import { email, required } from 'vuelidate/lib/validators'
import ModalV2 from '@/components/modals/ModalV2.vue'
import InputFileV2 from '@/components/inputsV2/InputFileV2.vue'
import ScrollView from '@/components/ScrollView.vue'
import InputMoney from '@/components/inputsV2/InputMoney.vue'
import MultiSelectV2 from '@/components/inputsV2/MultiSelectV2.vue'

@Component({
  props: {
    user: {
      type: Object
    }
  },
  components: {
    InputMoney,
    ScrollView,
    ModalV2,
    Icon,
    InputValidator,
    SelectV2,
    InputV2,
    DateInput2,
    InputFileV2,
    MultiSelectV2
  }
})
export default class AddAdminModal extends Vue {
  userModuleInstance: UserModule = getModule(UserModule, this.$store)

  userRole: number | null = null
  email: string = ''
  firstName: string = ''
  lastName: string = ''

  commissionSettings: {
    settings: Array<{
      rate: number | string;
      startDate: Date;
      minRev: number | string;
      brackets: number | string;
    }>
  } = {
    settings: [{
      rate: '',
      minRev: '',
      startDate: new Date(),
      brackets: ''
    }]
  }
  image: File | null = null

  isLoading: boolean = false
  userQaReports: string[] = []

  validations () {
    return {
      firstName: { required },
      lastName: { required },
      email: { required, email },
      userRole: { required }
    }
  }

  get reportsAvailable () {
    return this.userRole !== ZUNTA_DATA_ENTRY_ID
  }

  get userAvatarPath () {
    return this.$props.user ? `${STORAGE_URL}?file=` : ''
  }

  get userRoles () {
    return this.$store.state.permissions.roles
  }

  get userRolesList () {
    return this.userRoles.map((role: IUserChainRole) => ({
      key: role.id,
      value: role.id,
      content: role.name
    }))
  }

  get reportsList () {
    const reportLabels = {
      QA_SQL_REPORT: 'QA SQL Report',
      QA_CHAIN_AUTO_UPDATE_REPORT: 'Morning Chain Update QA Report',
      EMPTY_BATCHES_REGENERATION_REPORT: 'Empty Batches Regeneration Report',
      QA_DEPOSITS_REPORT: 'Deposits report',
      PAYMENTS_WITH_NO_WILLOW_ID_REPORT: 'Pending/Declined Payments with no WillowId'
    }
    const options: { key: string, value: string, content: string }[] = []
    for (const key in reportLabels) {
      if (!reportLabels.hasOwnProperty(key)) {
        continue
      }
      // @ts-ignore
      options.push({ key, value: key, content: reportLabels[key] })
    }
    return options
  }

  async mounted () {
    if (this.$props.user) {
      try {
        this.firstName = this.$props.user.firstName
        this.lastName = this.$props.user.lastName
        this.email = this.$props.user.email
        this.userRole = this.$props.user.role.id
        this.image = this.$props.user.avatar || ''

        this.commissionSettings = {
          settings: [...(this.$props.user.commissionSettings.settings || [])]
        }
        const reports = await this.userModuleInstance.getQaReportsSettings(this.$props.user.id)

        if (reports.length) {
          this.userQaReports = reports
        }
      } catch (e) {
        console.log(e)
      }
    }
  }

  async add () {
    this.$v.$touch()
    if (this.$v.$anyError) {
      return
    }

    this.isLoading = true
    if (this.$props.user) {
      await this.userModuleInstance.saveQaReportsSettings({ userId: this.$props.user.id, reports: this.userQaReports })
      if (this.image) {
        await this.uploadAvatar(this.$props.user.id)
      }
      await this.userModuleInstance.updateUser({
        id: this.$props.user.id,
        data: {
          role: this.userRole as number,
          type: EUserType.ZUNTA,
          firstName: this.firstName,
          lastName: this.lastName,
          isCustomPermissions: false,
          timezone: -5,
          commissionSettings: {
            settings: this.commissionSettings.settings.filter((setting: any) => setting.rate && setting.minRev && setting.brackets)
          }
        },
        type: 'admin'
      })
      this.$emit('close')
    } else {
      const response = await this.userModuleInstance.createUser({
        data: {
          role: this.userRole as number,
          type: EUserType.ZUNTA,
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          isCustomPermissions: false,
          timezone: -5,
          commissionSettings: {
            settings: this.commissionSettings.settings.filter((setting: any) => setting.rate && setting.minRev && setting.brackets)
          }
        },
        type: 'admin'
      })
      if (!response.error) {
        if (this.image) {
          await this.uploadAvatar(response.id)
        }
        await this.userModuleInstance.saveQaReportsSettings({ userId: response.id, reports: this.userQaReports })
        this.$emit('close')
      }
      if (response.statusCode === 409) {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-error-color)',
          message: 'Email already exists',
          header: `Error`,
          icon: 'warning'
        })
      }
    }
    this.isLoading = false
  }

  addSetting () {
    this.commissionSettings.settings.push({
      rate: '',
      startDate: new Date(),
      minRev: '',
      brackets: ''
    })
  }

  removeSettings (index: number) {
    this.commissionSettings.settings.splice(index, 1)
  }

  setAvatar (file: File) {
    this.image = file
  }

  async uploadAvatar (userId: number) {
    await this.userModuleInstance.uploadAvatar({
      userId: userId,
      file: this.image
    })
  }
}
